import styles from "./HeaderSearch.module.scss";
import icons from "helpers/icons";
import { useState, useEffect, useRef } from "react";
import { useQuery } from "react-query";
import useAPI from "../../../../hooks/useAPI";
import LoadingWrapper from "../../../Loading/LoadingWrapper";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useDebounce from "../../../../hooks/useDebounce";
import { useTranslation } from "react-i18next";

const HeaderSearch = ({ search = "", setSearch = () => {}, onSubmit, translateKey }) => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const api = useAPI();
    const [searchTerm, setSearchTerm] = useState("");
    const debouncedSearch = useDebounce(searchTerm, 700);
    const [searchTag, setSearchTag] = useState("");
    // const focusIndexRef = useRef(-1);
    const [keyDownState, setKeyDownState] = useState({ cursor: -1 });
    const {
        data: searchResults,
        isSuccess,
        ...basic
    } = useQuery(["CataloguePage.SearchResults", debouncedSearch], async () => {
        if (debouncedSearch?.length >= 3) {
            return await api.list(`/products/search/list`, { search: debouncedSearch, limit: 6, search_tag: searchTag }).then((res) => {
                setSearchTag("");
                return res;
            });
        }
    });

    useEffect(() => {
        if (debouncedSearch && debouncedSearch?.length >= 3) {
            // Perform the query again with the updated searchTerm
            basic.refetch();
        }
    }, [debouncedSearch]);

    const searchRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setSearchTerm("");
                setSearch("");
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [searchRef]);

    const handleKeyDown = (e) => {
        const { cursor } = keyDownState;
        if (e.key === "ArrowDown" && cursor < searchResults?.items.length - 1) {
            e.preventDefault();
            setKeyDownState((prevState) => ({
                cursor: prevState.cursor + 1,
            }));
        } else if (e.key === "ArrowUp" && cursor > 0) {
            e.preventDefault();
            setKeyDownState((prevState) => ({
                cursor: prevState.cursor - 1,
            }));
        } else if (e.key === "Enter" && cursor >= 0 && searchResults?.items.length > 0) {
            e.preventDefault();
            const selectedProduct = searchResults?.items[cursor];
            navigate(`/katalog/artikal/${selectedProduct?.id}`);
            setSearchTerm("");
            setSearch("");
        }
    };

    useEffect(() => {
        setKeyDownState({ cursor: -1 });
    }, [debouncedSearch]);

    return (
        <form
            data-tour="search"
            className={styles.form}
            onSubmit={(e) => {
                if (searchTerm?.length >= 3) {
                    e.preventDefault();
                    // searchTag sluzi za cuvanje termina po kojima se vrsila pretraga od strane korisnika, zbog problema prosledjivanja search_taga-a na listi okidamo ovde da bi se sacuvala vrednost kada korisnik klikne enter, NIJE DOBRO jer se search lista dva puta okida
                    searchTag?.length > 0 &&
                        api.list(`/products/search/list`, { search: searchTerm, limit: 6, search_tag: searchTag }).then((res) => {
                            setSearchTag("");
                        });
                    navigate(`/katalog/pretraga/` + encodeURIComponent(searchTerm));
                    setSearchTerm("");
                    setSearchTag("");
                } else {
                    e.preventDefault();
                    toast.error(t(`${translateKey}-messages-enter_least_3_char`));
                }
            }}
            ref={searchRef}
        >
            <input
                type="text"
                placeholder="Pretražite proizvode"
                value={searchTerm}
                onChange={(e) => {
                    if (search != e.target.value) {
                        setSearch(e.target.value);
                    }
                }}
                onInput={(e) => {
                    setSearchTerm(e.target.value);
                    setSearchTag(e.target.value);
                }}
                onKeyDown={handleKeyDown}
            />
            <button type="submit" className={styles.button} aria-label="Pretražite proizvode">
                <img src={icons.search} alt="" />
            </button>
            {searchTerm?.length >= 3 && (
                <div className={styles.results}>
                    <LoadingWrapper isLoading={basic.isLoading}>
                        {searchResults?.items?.map((item, index) => (
                            <Link
                                key={item.id}
                                className={`${styles.result} ${keyDownState.cursor === index ? styles.focused : ""}`}
                                to={`/katalog/artikal/${item?.id}`}
                                onClick={() => {
                                    setSearchTerm("");
                                    setSearch("");
                                }}
                            >
                                <span className={styles.thumbnail} aria-hidden="true">
                                    {item.images?.[0] && <img src={item.images[0]} alt="" onError={(event) => { event.currentTarget.style.display = "none"; }} />}
                                </span>
                                <span className={styles.info}>{item?.basic_data?.name}</span>
                            </Link>
                        ))}
                        {searchResults?.pagination?.total_items > 6 && (
                            <div className={styles.moreresults}>
                                <Link
                                    onClick={() => {
                                        setSearchTerm("");
                                        setSearch("");
                                    }}
                                    to={`/katalog/pretraga/${encodeURIComponent(searchTerm)}`}
                                    className={styles.allResultsLink}
                                >
                                    {`${t(`${translateKey}-messages-show_all_res`)} (${t(`${translateKey}-more`)} ${searchResults?.pagination?.total_items - searchResults?.items?.length})`}
                                </Link>
                            </div>
                        )}
                    </LoadingWrapper>
                </div>
            )}
        </form>
    );
};

export default HeaderSearch;
